import React, { useState } from 'react';
import listMyHomeImage from 'large/list-my-home.jpg';
import ListMyHomeModal from './ListMyHomeModal';

export default function ListMyHome({ data, current_user, areas }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="list-my-home">
        <div className="image-overlay" />
        <picture className="background-picture">
          <img data-src={listMyHomeImage} className="lazyload" alt="" />
        </picture>

        <h2>Selling your own home?</h2>

        <p>
          Our trusted Realty One Group Agents can help you list your amazing
          property on DestinFlorida.com
        </p>

        <button
          type="button"
          className="btn btn--white"
          onClick={() => {
            setShowModal(true);
            // TODO: Refactor. W/out this, the ListMyHomeModal gets rendered at the top of the page on Mobile
            document.querySelector('.mls-show-page-container').style.height =
              '100%';
          }}
        >
          List My Home
        </button>
      </div>
      {showModal && (
        <ListMyHomeModal
          data={data}
          current_user={current_user}
          closeModal={() => setShowModal(false)}
          areas={areas}
        />
      )}
    </>
  );
}
